const cookieKeys = {
  // must be registered as a "necessary" cookie in CookieYes, or it gets blocked without consent
  AUTH_REDIRECT: 'auth_redirect',
} as const;

export { cookieKeys };
